import React, { useEffect, useState } from 'react';
import { ArrowRight, CheckCircle2, Clock, Users } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('hb-timer-end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    const end = Date.now() + 2 * 60 * 60 * 1000;
    sessionStorage.setItem('hb-timer-end', end.toString());
    return 2 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="offer-section" className="py-20 bg-gradient-to-b from-white to-[#e8f4fc]" data-id="element-67">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-69">
          <div className="bg-[#1e4d7b] p-6 text-center" data-id="element-70">
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-71">
              Llévate el pack completo por un precio especial
            </h2>
          </div>

          {/* Urgency Banner */}
          <div className="bg-red-50 border-b border-red-100 px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 text-center" data-id="element-72">
            <div className="flex items-center gap-2 text-red-600 font-semibold text-sm" data-id="element-73">
              <Clock className="h-4 w-4 animate-pulse" data-id="element-74" />
              <span data-id="element-75">Oferta válida por:</span>
            </div>
            <div className="flex items-center gap-1 font-mono text-lg font-bold text-red-700" data-id="element-76">
              <span className="bg-red-100 px-2 py-0.5 rounded" data-id="element-77">
                {pad(hours)}
              </span>
              <span data-id="element-78">:</span>
              <span className="bg-red-100 px-2 py-0.5 rounded" data-id="element-79">
                {pad(minutes)}
              </span>
              <span data-id="element-80">:</span>
              <span className="bg-red-100 px-2 py-0.5 rounded" data-id="element-81">
                {pad(seconds)}
              </span>
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-82">
            {/* Spots remaining */}
            <div className="flex items-center justify-center gap-2 mb-8 text-sm" data-id="element-83">
              <Users className="h-4 w-4 text-orange-500" data-id="element-84" />
              <span className="text-gray-600" data-id="element-85">
                Solo quedan{' '}
                <strong className="text-orange-600" data-id="element-86">23 cupos</strong> a este
                precio
              </span>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-10" data-id="element-87">
              <div className="space-y-4 w-full md:w-1/2" data-id="element-88">
                <div className="flex justify-between items-center text-gray-500 line-through" data-id="element-89">
                  <span data-id="element-90">Guía Maestra Hogar Blindado</span>
                  <span data-id="element-91">27€</span>
                </div>
                <div className="flex justify-between items-center text-gray-500 line-through" data-id="element-92">
                  <span data-id="element-93">Audio-Entrenamiento Rápido</span>
                  <span data-id="element-94">17€</span>
                </div>
                <div className="flex justify-between items-center text-gray-500 line-through" data-id="element-95">
                  <span data-id="element-96">Calendario "Cero Reinfestación"</span>
                  <span data-id="element-97">12€</span>
                </div>
                <div className="h-px bg-gray-200 my-4" data-id="element-98"></div>
                <div className="flex justify-between items-center text-2xl text-red-500 font-bold" data-id="element-99">
                  <span data-id="element-100">VALOR TOTAL:</span>
                  <span className="line-through" data-id="element-101">56€</span>
                </div>
              </div>

              <div className="w-full md:w-1/2 bg-[#e8f4fc] rounded-2xl p-6 text-center border-2 border-[#4a90c2]" data-id="element-102">
                <p className="text-[#1e4d7b] font-medium mb-2" data-id="element-103">
                  OFERTA LIMITADA
                </p>
                <p className="text-sm text-gray-600 mb-4" data-id="element-104">
                  Hoy todo el pack por solo
                </p>
                <div className="text-5xl font-bold text-[#1e4d7b] mb-2" data-id="element-105">
                  6,50€
                </div>
                <p className="text-xs text-gray-500" data-id="element-106">
                  Pago único • Acceso de por vida
                </p>
              </div>
            </div>

            <div className="text-center space-y-6" data-id="element-107">
              <motion.a href="https://go.hotmart.com/M104264502J?dp=1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full md:w-auto px-10 py-5 bg-[#1e4d7b] hover:bg-[#163a5e] text-white font-bold text-xl rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 mx-auto" data-id="element-108">
                Quiero acceso a Hogar Blindado
                <ArrowRight className="h-6 w-6" data-id="element-109" />
              </motion.a>

              <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-110">
                <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-111" />
                <span data-id="element-112">Garantía de satisfacción</span>
                <span className="mx-2" data-id="element-113">•</span>
                <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-114" />
                <span data-id="element-115">Pago seguro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}